export enum ETipoDocumento {
    CPF = 1,
    CNPJ = 2,
    Estrangeiro = 3,
}
